/*
* @Author: ssxu9
* @Date:   2016-04-04 21:10:03
* @Last Modified by:   ssxu9
* @Last Modified time: 2016-04-09 20:27:29
*/

require('es6-promise').polyfill()
require('isomorphic-fetch')

import {
    SET_USER_ID,
    SET_USER_NAME,
    SET_TASK_ID,
    SET_COMPLETE_ANS,
    SET_BASE_INFO,
    SET_PROCESS_ID,
    SET_NEXT_PROCESS_ID,
    SET_NODE_INFO,
    SET_USER_LIST,
    SET_CHECKED_USER,
    SET_COUNT
} from './mutation-types'

export const setUserId = makeAction(SET_USER_ID)
export const setUserName = makeAction(SET_USER_NAME)
export const setTaskId = makeAction(SET_TASK_ID)
export const setCompleteAns = makeAction(SET_COMPLETE_ANS)
export const setBaseInfo = makeAction(SET_BASE_INFO)
export const setProcessId = makeAction(SET_PROCESS_ID)
export const setNextProcessId = makeAction(SET_NEXT_PROCESS_ID)
export const setNodeInfo = makeAction(SET_NODE_INFO)
export const setUserList = makeAction(SET_USER_LIST)
export const setCheckedUser = makeAction(SET_CHECKED_USER)
export const setCount = makeAction(SET_COUNT)
function makeAction (type) {
    return ({ dispatch }, ...args) => dispatch(type, ...args)
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js